export const COLUMN_KEYS = [
  'attachments',
  'gfsi',
  'export',
  'halal',
  'kosher',
  'exportable',
  'counteronly',
  'exportdocs',
  'callofftime',
  'origins',
  'locations',
  'age',
  'fromaddr',
  'toaddr',
  'incoterms',
  'buyer',
  'consignee',
  'paymentterm',
  'reference_price',
  'variants',
] as const;

export type ColumnKeys = (typeof COLUMN_KEYS)[number];

// One new-participants toast per solution: react-toastify ignores a toast
// whose id is already showing, so repeat calls cannot stack copies.
export const participantToastId = (solutionId: string) =>
  `new-participants-${solutionId}`;
